import React from 'react'
import { useNavigate } from "react-router-dom";
function Header() {
    const storedSchoolName = localStorage.getItem("schoolName") || "School Name Not Available";
    const navigate = useNavigate();
    const moveToLogin = (e) => {
        e.preventDefault();
        localStorage.removeItem("token2");
        localStorage.removeItem("schoolName");
        localStorage.removeItem("CentCode");
        localStorage.removeItem("sessionId2");
        navigate("/board");
    };
    return (

        <header class="pc-header">
            {/* <h4>Centre Name </h4> */}
            <div class="header-wrapper">
                <div class="me-auto pc-mob-drp">
                    <ul class="list-unstyled">
                        <li class="pc-h-item pc-sidebar-collapse">
                            <a class="pc-head-link ms-0" id="sidebar-hide">
                                <i class="ti ti-menu-2"></i>
                            </a>
                        </li>
                        <li class="pc-h-item pc-sidebar-popup">
                            <a href="#" class="pc-head-link ms-0" id="mobile-collapse">
                                <i class="ti ti-menu-2"></i>
                            </a>
                        </li>
                        <li class="dropdown pc-h-item d-inline-flex d-md-none">
                            <a
                                class="pc-head-link dropdown-toggle arrow-none m-0"
                                data-bs-toggle="dropdown"
                                href="#"
                                role="button"
                                aria-haspopup="false"
                                aria-expanded="false">
                                <i class="ti ti-search"></i>
                            </a>
                            <div class="dropdown-menu pc-h-dropdown drp-search">
                                <form class="px-3">
                                    <div class="form-group mb-0 d-flex align-items-center">

                                        <input type="search" class="form-control border-0 shadow-none" placeholder="Search here. . ." />
                                    </div>
                                </form>
                            </div>
                        </li>
                        <li class="pc-h-item d-none d-md-inline-flex">
                            <h5 className='exam-name' style={{ marginTop: '10px' }}>Supplementary Examination Portal</h5>
                        </li>
                    </ul>
                </div>
                <div class="ms-auto">
                    <ul class="list-unstyled">
                        <li class="dropdown pc-h-item header-user-profile">
                            <a
                                class="pc-head-link me-0" style={{cursor:'context-menu'}}
                                role="button">
                                <img src="../assets/images/MBOSE.png" alt="user-image" class="user-avtar" />
                                <h4></h4>
                                <span className='centrename' style={{textTransform:'uppercase',fontWeight:'bold'}}>
                                    BOARD
                                    </span>
                            </a>
                            {/* <div class="dropdown-menu dropdown-user-profile dropdown-menu-end pc-h-dropdown">
                                <div class="dropdown-header">
                                    <div class="d-flex mb-1">
                                        <div class="flex-shrink-0">
                                            <img src="../assets/images/MBOSE.png" alt="user-image" class="user-avtar wid-35" />
                                        </div>
                                        <div class="flex-grow-1 ms-3">
                                      <h6 class="mb-1">Risa Higher Secondary School, Shilong</h6> 
                                           <span>UI/UX Designer</span> 
                                        </div>
                                        <a href="" class="pc-head-link" onClick={moveToLogin}><i class="ti ti-power text-danger"></i> <span className='logout'>Logout</span></a>
                                    </div>
                                </div>
                              
                            </div> */}
                        </li>
                        <li class="dropdown pc-h-item header-user-profile">
                        <a href="" class="pc-head-link" onClick={moveToLogin}><i class="ti ti-power text-danger"></i> <span className='logout'>Logout</span></a>
                        </li>
                    </ul>
                </div>
            </div>
        </header>
    )
}

export default Header